import { api } from "@/lib/api";

export type StatusPodobnosti = "podoban" | "nepodoban";
export type StanjeRazloga = "nedostaje_podatak" | "istekao" | "nevaljan";

export interface RazlogSpiska {
  obligation: string;
  state: StanjeRazloga;
  due_on: string | null;
}

export interface RadnikSpiska {
  na_bolovanju?: boolean;
  stanje_doznake?: "nema" | "ima" | "neslaganje" | null;
  radnik_id: string;
  raspored_id: string;
  brigada_id: string | null;
  brigada: string | null;
  vrijedi_od: string;
  uskoro: { naziv: string; rok: string; dana_do: number }[];
  ceka_odobrenje: boolean;
  full_name: string;
  job_position: string | null;
  assigned_from: string;
  employer: string;
  presence_basis: string;
  eligibility: StatusPodobnosti;
  reasons: RazlogSpiska[];
  permit_status: "važeća" | "istekla" | "nedostaje" | null;
  permit_valid_until: string | null;
  znr_valid: boolean;
  ra2_valid: boolean;
  ra2_valid_until: string | null;
  override_active: boolean;
  override_reason: string | null;
}

export interface PregledGradilista {
  id: string;
  naziv: string;
  adresa: string | null;
  voditelj: string | null;
  broj_radnika: number;
  ne_smije: number;
  uskoro: number;
  sati_jucer: { upisano: number; ukupno: number };
  radnici: {
    radnik_id: string;
    full_name: string;
    eligibility: StatusPodobnosti;
    reasons: RazlogSpiska[];
  }[];
}

export interface NerasporedenRadnik {
  radnik_id: string;
  full_name: string;
  job_position: string | null;
  zadnje_gradiliste: string | null;
  zadnji_dan: string | null;
  eligibility: StatusPodobnosti;
  reasons: RazlogSpiska[];
  odsutnost: string[];
}

export interface PregledPopisa {
  gradilista: PregledGradilista[];
  bez_gradilista: NerasporedenRadnik[];
  brojaci: {
    ukupno_radnika: number;
    ne_smije: number;
    uskoro: number;
    bez_gradilista: number;
  };
}

export async function dohvatiPregledPopisa(
  date: string,
  signal?: AbortSignal,
): Promise<PregledPopisa> {
  return (
    await api.get<PregledPopisa>("/gradilista/spisak/pregled", {
      params: { date },
      signal,
    })
  ).data;
}

export interface GradilisniSpisak {
  site_name: string;
  dossier_date: string;
  generated_at: string;
  contractor_count: number;
  workers: RadnikSpiska[];
  pending_workers: RadnikSpiska[];
}

export async function dohvatiGradilisniSpisak(
  gradilisteId: string,
  date: string,
  signal?: AbortSignal,
): Promise<GradilisniSpisak> {
  const response = await api.get<GradilisniSpisak>(
    `/gradilista/${gradilisteId}/spisak`,
    { params: { date }, signal },
  );
  return response.data;
}

export async function preuzmiGradilisniSpisakPdf(
  gradilisteId: string,
  date: string,
): Promise<void> {
  const response = await api.get<Blob>(
    `/gradilista/${gradilisteId}/spisak/pdf`,
    {
      params: { date },
      responseType: "blob",
    },
  );
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = `gradilisni-spisak-${date}.pdf`;
  link.click();
  URL.revokeObjectURL(url);
}
